import React, { useState } from "react";

type Props = {
  children: JSX.Element;
};

type RegistrationSteps = {
  isEmail: boolean;
  isPassword: boolean;
  // isVerifyOtp: boolean;
  isVerified: boolean;
};

type RegisterEnumeratorContextProps = {
  registrationSteps: RegistrationSteps;
  setRegistrationSteps: React.Dispatch<React.SetStateAction<RegistrationSteps>>;
};
const initialState = { isEmail: true, isPassword: false, isVerified: false };

export const RegisterEnumeratorContext = React.createContext<RegisterEnumeratorContextProps>({
  registrationSteps: initialState,
  setRegistrationSteps: () => null,
});

const RegisterEnumeratorContextProvider = ({ children }: Props) => {
  const [registrationSteps, setRegistrationSteps] = useState<RegistrationSteps>(initialState);

  return (
    <RegisterEnumeratorContext.Provider
      value={{
        registrationSteps,
        setRegistrationSteps,
      }}
    >
      {children}
    </RegisterEnumeratorContext.Provider>
  );
};

export const useRegisterEnumeratorContext = () => {
  const context = React.useContext(RegisterEnumeratorContext);

  if (context === undefined) {
    throw new Error("context must be used within a Context Provider");
  }

  return context;
};

export default RegisterEnumeratorContextProvider;
